import { getFileExtension } from '../../../features/Filesystem'
import { FileInfo } from '../../../utils/types'
import Konva from 'konva'

/**
 * Returns true if the given shape configuration is a rectangle.
 * @param shape Konva shape configuration.
 */
export function isRectangleConfig(shape: Konva.ShapeConfig): shape is Konva.RectConfig {
  if ('shapeType' in shape) return shape.shapeType === 'Rectangle'
  // other than the className, there is no distinct way of telling whether the
  // config is a rectangle or not -> use exclusion process
  return !isCircleConfig(shape) && !isEllipseConfig(shape)
}
/**
 * Returns true if the given shape configuration is a circle.
 * @param shape Konva shape configuration.
 */
export function isCircleConfig(shape: Konva.ShapeConfig): shape is Konva.CircleConfig {
  if ('shapeType' in shape) return shape.shapeType === 'Circle'
  return 'radius' in shape && typeof shape.radius !== 'object'
}
/**
 * Returns true if the given shape configuration is an ellipse.
 * @param shape Konva shape configuration.
 */
export function isEllipseConfig(shape: Konva.ShapeConfig): shape is Konva.EllipseConfig {
  if ('shapeType' in shape) return shape.shapeType === 'Ellipse'
  return 'radiusX' in shape && 'radiusY' in shape
}

export function isSupportedImageFormat(file: FileInfo): boolean {
  const ext = getFileExtension(file.name as string)
  return ['png', 'PNG', 'jpeg', 'JPEG', 'jpg', 'JPG', 'webp', 'webP', 'WEBP'].includes(
    ext as string
  )
}

export function buildVirtualStage(
  imageBitmap: ImageBitmap,
  shapeConfigs: Konva.ShapeConfig[]
): Konva.Stage {
  // 1. Create a stage that only lives in memory (will not be rendered to the screen)
  const stage = new Konva.Stage({
    // Konva Stage requires a container element, even when the container is not
    // inserted into the DOM
    container: document.createElement('div'),
    width: imageBitmap.width,
    height: imageBitmap.height,
  })
  const layer = new Konva.Layer()

  // 2. Add the image to our virtual stage
  const image = new Konva.Image({
    // load the image using the Bitmap
    image: imageBitmap,
    // specify image position on the canvas
    x: 0,
    y: 0,
    // specify image dimensions
    width: imageBitmap.width,
    height: imageBitmap.height,
  })
  layer.add(image)

  // 3. Add all shapes on top of the image
  shapeConfigs.forEach(config => {
    console.log('adding shape ->', config)
    if (isEllipseConfig(config)) layer.add(new Konva.Ellipse(config))
    else layer.add(new Konva.Rect(config))
  })

  // 4. Return the virtual Stage
  stage.add(layer)
  return stage
}
